<template >
  <head>
    <meta charset="UTF-8">
  </head>
<div v-if="!isMobile"  class="background">
<!--  公司名-->
<!--  <div class="header">-->
<!--      <div :style="getColorStyles()" style="width:10%;margin-left: auto;margin-right: 3%;margin-top: 70px;font-size: 48px" >{{this.productDetail.shortCompanyName}}-->
<!--      </div>-->



<!--  </div>-->

  <div style="width:100%;height:38%;display:flex;margin-top: 1%">
   <div style="height:100%">
     <el-image  :preview-src-list="putPhotoToArray(this.productDetail.productPhoto)" style="height: 100%" :src="this.productDetail.productPhoto" :initial-index="0"
                alt="" fit="cover"/>
   </div>
    <div style="width:70%;height:100%">
      <div style="height: 15%;margin-top: 2%;">
        <div style="width: 60%;margin-left:  40%;height: 100%;display: flex">

          <div style="width: 25%;height: 100%;display: flex;justify-content: center;align-items: center">
            <div style="height: 100%;width: 50%">
              <img style="height: 100%" src="https://www.haranz.com:8888/assets/header-computer.png"/>
            </div>
            <div style="font-size: 24px;font-weight: bold;margin-left: 10px;width: 50%">专业</div>
          </div>

          <div style="width: 25%;height: 100%;display: flex;justify-content: center;align-items: center;margin-left: 5%">
            <div style="height: 100%;width: 50%">
              <img style="height: 100%" src="https://www.haranz.com:8888/assets/header-masonry.png"/>
            </div>
            <div style="font-size: 24px;font-weight: bold;margin-left: 10px;width: 50%">品质</div>
          </div>

          <div style="width: 25%;height: 100%;display: flex;justify-content: center;align-items: center;margin-left: 5%">
            <div style="height: 100%;width: 50%">
              <img style="height: 100%" src="https://www.haranz.com:8888/assets/header-loveicon.png"/>
            </div>
            <div style="font-size: 24px;font-weight: bold;margin-left: 10px;width: 50%">服务</div>
          </div>

        </div>

      </div>

      <div style="margin-top:1%;height: 3%;background-color: RGB(69,69,69)"></div>
      <div  :style="getBackgroundColorStyles()" style="height: 55%;display: flex;justify-content: center;align-items: center;;font-size: 80px;color: white">
        {{this.productDetail.companyName}}

      </div>


      <div style="height: 3%;background-color: RGB(69,69,69)"></div>

      <div style="height: 15%;width:100%;">
        <img style="height: 100%;margin-left: 45%" src="https://www.haranz.com:8888/assets/back-grey.png"/>
        <img style="height: 100%" src="https://www.haranz.com:8888/assets/back-orange.png"/>

      </div>
    </div>



  </div>

  <div style="width:100%;height:10%;display: flex">
    <div style="width: 20%;height:100%;margin-left: auto;margin-top:3%;display:flex;align-items: center;justify-content:center;font-size: 48px">竭诚为您服务</div>
  </div>


  <div style="width:100%;height:8%;display: flex;margin-top: 5%">
    <div style="width: 100%;display:flex;align-items: center;justify-content:center;font-size: 48px;font-weight: bold">{{this.productDetail.productNumber}}
    </div>

  </div>

  <div style="width:100%;height:8%;display: flex;margin-top: 3%">
    <div style="width: 100%;display:flex;align-items: center;justify-content:center;font-size: 48px">{{this.productDetail.productSimpleInfo}}
    </div>

  </div>

  <div style="width: 100%;height: 65%;position:relative;">
    <div style="width: 100%;display:flex;align-items: center;justify-content:center;font-size: 48px">{{this.productDetail.modelNumberPrefix}}
      <div style="font-weight: bold;display:flex;align-items: center;justify-content:center">{{this.productDetail.modelNumber}}</div>
    </div>
    <div style="width: 100%;display:flex;align-items: center;justify-content:center;font-size: 48px">{{this.productDetail.batchNumberPrefix}}
      <div style="font-weight: bold;display:flex;align-items: center;justify-content:center">{{this.productDetail.batchNumber}}</div>
      </div>
     <div style="height: 90%;display:flex;">
       <div style="width: 35%;height:100%;margin-top:3%;position: relative">
         <div style="border-radius: 50%;background-color: orange;position: absolute;height: 150px;width:150px;top: -75px;left: -75px;z-index: 999;display:flex;align-items: center;justify-content:center;color: white;font-weight: bold ">研发成果
         </div>
         <img :src="this.productDetail.certificateList[0].certificatePhoto" style="height: 55%;position: absolute;left: 0%;top: 0%"/>
         <img :src="this.productDetail.certificateList[1].certificatePhoto" style="height: 55%;position: absolute;left: 10%;top: 10%"/>
         <img :src="this.productDetail.certificateList[2].certificatePhoto" style="height: 55%;position: absolute;left: 20%;top: 20%"/>
         <img :src="this.productDetail.certificateList[3].certificatePhoto" style="height: 55%;position: absolute;left: 30%;top: 30%"/>
         <div style="font-size: 32px;width: 100%;;display:flex;align-items: center;justify-content:center;position: absolute;left: 0;bottom: 0;">发明专利</div>

       </div>
       <div style="width: 65%;height:100%;margin-top:3%;position: relative">
         <div style="height: 20%;width: 100%;display: flex">

           <div>
             <img style="height: 100%" src="https://www.haranz.com:8888/assets/warning.png"/>
           </div>

           <div style="font-size: 30px;color: RGB(255,0,0);height: 100%;display:flex;align-items: center;justify-content:center">{{this.productDetail.safetyTips}}
           </div>



         </div>

         <div v-if="this.productDetail.safetyTipsInfo" style="height: 10%;width: 100%;display: flex;margin-top: 5%">

           <div style="font-size: 30px;color: RGB(255,0,0);height: 100%;display:flex;align-items: center;justify-content:center;width: 80%;margin-left: 20%">{{this.productDetail.safetyTipsInfo}}
           </div>


         </div>

         <div style="margin-top: auto;width: 100%;height:30%;position:absolute;left: 0;bottom: 0;">
           <div v-if="productDetail.pdfUrl != null" style="width: 75%;margin-left:25%;height: 33%;display:flex;align-items: center;justify-content:left;font-size: 32px">
             <img src="https://www.haranz.com:8888/assets/point.png">
             <el-link :href="productDetail.pdfUrl" type="primary"  style="font-size: 32px!important"> 检验报告(点击下载)</el-link>
           </div>
           <div style="width: 75%;margin-left:25%;height: 33%;display:flex;align-items: center;justify-content:left;font-size: 32px">
                     <img src="https://www.haranz.com:8888/assets/point.png">地址： {{this.productDetail.address}}
           </div>
           <div style="width: 75%;margin-left:25%;height: 33%;display:flex;align-items: center;justify-content:left;font-size: 32px">
             <img src="https://www.haranz.com:8888/assets/point.png">联系电话：{{this.productDetail.phone}}
           </div>

         </div>
       </div>
     </div>

  </div>

  <div style="width: 100%;height: 25%;;">

  </div>


</div>

  <div v-if="isMobile" class="home">
    <!--  公司名-->
<!--    <header class="mobileHeader">-->
<!--      <h1  :style="getColorStyles()">{{this.productDetail.shortCompanyName}}</h1>-->
<!--    </header>-->
    <main class="content">
      <div style="width: 100%;height: 20%;display: flex;justify-content: space-around">

        <div style="width: 25%;height: 100%;display: flex;justify-content: center;align-items: center">
          <div style="height: 100%;width: 50%">
            <img style="height: 100%" src="https://www.haranz.com:8888/assets/header-computer.png"/>
          </div>
          <div style="font-size: 24px;font-weight: bold;margin-left: 10px;width: 50%">专业</div>
        </div>

        <div style="width: 25%;height: 100%;display: flex;justify-content: center;align-items: center;margin-left: 5%">
          <div style="height: 100%;width: 50%">
            <img style="height: 100%" src="https://www.haranz.com:8888/assets/header-masonry.png"/>
          </div>
          <div style="font-size: 24px;font-weight: bold;margin-left: 10px;width: 50%">品质</div>
        </div>

        <div style="width: 25%;height: 100%;display: flex;justify-content: center;align-items: center;margin-left: 5%">
          <div style="height: 100%;width: 50%">
            <img style="height: 100%" src="https://www.haranz.com:8888/assets/header-loveicon.png"/>
          </div>
          <div style="font-size: 24px;font-weight: bold;margin-left: 10px;width: 50%">服务</div>
        </div>

      </div>
      <div style="height:200px;width: 100%;margin-top: 1%;display: flex">
        <div style="width: 50%;height: 100%">
          <el-image  :src="this.productDetail.productPhoto" :preview-src-list="putPhotoToArray(this.productDetail.productPhoto)" style="width: 100%;height: 100%"  :initial-index="0"
                     alt="" fit="cover"/>
        </div>

        <div style="width:50%;height:100%">

          <div style="margin-top:15%;height: 3%;background-color: RGB(69,69,69)"></div>
          <div :style="getBackgroundColorStyles()" style="height: 55%;display: flex;justify-content: center;align-items: center;;font-size: 24px;font-weight:bold;color: white">
            {{this.productDetail.companyName}}

          </div>
          <div style="height: 3%;background-color: RGB(69,69,69)"></div>

          <div style="height: 15%;width:100%;margin-top: 5%">
            <img style="width: 30%;height:100%;margin-left: 10%" src="https://www.haranz.com:8888/assets/back-grey.png"/>
            <img style="width: 30%;height: 100%;margin-left: 5%" src="https://www.haranz.com:8888/assets/back-orange.png"/>

          </div>
        </div>
      </div>

      <div style="width:100%;height:30px;margin-top:15px;display: flex">
        <div style="width: 40%;height:100%;margin-left: auto;margin-right:5%;margin-top:3%;display:flex;align-items: center;justify-content:center;font-size: 16px">竭诚为您服务</div>
      </div>

      <div style="width:100%;height:20px;display: flex;margin-top: 30px">
        <div style="width: 100%;display:flex;align-items: center;justify-content:center;font-size: 16px;font-weight: bold">{{this.productDetail.productNumber}}
        </div>

      </div>

      <div style="width:100%;height:20px;display: flex;margin-top: 20px">
        <div style="width: 100%;display:flex;align-items: center;justify-content:center;font-size: 16px">{{this.productDetail.productSimpleInfo}}
        </div>

      </div>

      <div style="width: 100%;display:flex;align-items: center;justify-content:center;font-size: 16px;margin-top: 15px">
        {{this.productDetail.modelNumberPrefix}}<div style="font-weight: bold;display:flex;align-items: center;justify-content:center;;height: 100%">{{this.productDetail.modelNumber}}</div></div>
      <div style="width: 100%;display:flex;align-items: center;justify-content:center;font-size: 16px;margin-top: 15px">
        {{this.productDetail.batchNumberPrefix}}<div style="font-weight: bold;display:flex;align-items: center;justify-content:center;height: 100%">{{this.productDetail.batchNumber}}</div>
      </div>

      <div style="height: 60px;width: 100%;display: flex;margin-top: 30px">

        <div>
          <img style="height: 100%;width: 60px" src="https://www.haranz.com:8888/assets/warning.png"/>
        </div>

        <div style="font-size: 16px;color: RGB(255,0,0);height: 100%;display:flex;align-items: center;justify-content:center">{{this.productDetail.safetyTips}}
        </div>




      </div>

      <div v-if="this.productDetail.safetyTipsInfo" style="height: 30px;width: 100%;display: flex;align-items: end;margin-top: 30px">


        <div style="font-size: 16px;color: RGB(255,0,0);height: 100%;width:80%;display:flex;align-items: center;justify-content:center;margin-left: 60px">{{this.productDetail.safetyTipsInfo}}</div>




      </div>

      <div style="width: 60%;margin-left:20%;height:450px;margin-top:100px;position: relative;">
        <div style="border-radius: 50%;background-color: orange;position: absolute;height: 70px;width:70px;top: -35px;left: -35px;z-index: 999;display:flex;align-items: center;justify-content:center;color: white;font-weight: bold ">研发成果
        </div>
        <img :src="this.productDetail.certificateList[0].certificatePhoto"  style="height: 55%;position: absolute;left: 0%;top: 0%"/>
        <img :src="this.productDetail.certificateList[1].certificatePhoto" style="height: 55%;position: absolute;left: 10%;top: 10%"/>
        <img :src="this.productDetail.certificateList[2].certificatePhoto" style="height: 55%;position: absolute;left: 20%;top: 20%"/>
        <img :src="this.productDetail.certificateList[3].certificatePhoto" style="height: 55%;position: absolute;left: 30%;top: 30%"/>
        <div style="font-size: 16px;width: 100%;;display:flex;align-items: center;justify-content:center;position: absolute;left: 0;bottom: 0;">发明专利</div>

      </div>


      <div style="margin-top: 40px;width: 100%;height:160px;">
        <div v-if="productDetail.pdfUrl != null" style="width: 70%;margin-left:15%;height: 40px;display:flex;align-items: center;justify-content:left;font-size: 16px">
          <img src="https://www.haranz.com:8888/assets/point.png"><el-link :href="productDetail.pdfUrl" type="primary"  style="font-size: 16px!important"> 检验报告(点击下载)</el-link>
        </div>
        <div style="width: 70%;margin-left:15%;height: 40px;display:flex;align-items: center;justify-content:left;font-size: 16px">
          <img src="https://www.haranz.com:8888/assets/point.png"> 地址： {{this.productDetail.address}}
        </div>
        <div style="width: 70%;margin-left:15%;height: 40px;display:flex;align-items: center;justify-content:left;font-size: 16px;margin-top: 20px;margin-bottom: 20px">
          <img src="https://www.haranz.com:8888/assets/point.png">联系电话：{{this.productDetail.phone}}
        </div>

      </div>

    </main>
    <footer class="footer">
      <p>{{this.productDetail.companyName}}</p>
    </footer>
  </div>

</template>

<script>
import {FolderAdd} from "@element-plus/icons";
import { ElMessage } from 'element-plus'
let ws = null
export default {
  inject: ['reload'],
  name: "LightChatHome",
  components:{
    FolderAdd
  },
  data:function (){
    return{

      productDetail:{
         id:1,
        companyName:"",
        shortCompanyName:"",
        modelNumberPrefix:"",
        modelNumber:"",
        batchNumberPrefix:"",
        batchNumber:"",
        safetyTips:"",
        safetyTipsInfo:"",
        address:"",
        phone:"",
        productPhoto:"",
        productNumber:"",
        pdfUrl:null,
        color:"(1,1,1)",
        productSimpleInfo:"",
        certificateList:[{
          certificatePhoto:""
        },{
          certificatePhoto:""
        },{
          certificatePhoto:""
        },{
          certificatePhoto:""
        }],

      },



      isMobile:false,
    }
  },
  methods:{
    init(){
        this.getProductDetail()

    },
    getColorStyles(){
      return {
        color: this.productDetail.color,
      };
    },

    getBackgroundColorStyles(){
      return {
        backgroundColor: this.productDetail.color,
      };
    },

    getProductDetail(){
     let form = new FormData()
      let id = this.getParameterByName('id');
      id = id?id:1
      form.append("id",id)
      this.$axios.post('/huaran/productDetail/getProductDetail',form,this.$roleUtil.fillHeader()).then(resp=>{
        if (this.$roleUtil.checkResp(resp)) {
          console.log(resp)
          this.productDetail = resp.data.data
          //公司名
          document.title = this.productDetail.companyName || "宁波华然管业有限公司";
        }
      })
    },

    putPhotoToArray (src){
      let temp = []
      temp.push(src)
      return temp
    },

    checkDevice() {
      this.isMobile = window.innerWidth <= 768;
      console.log(this.isMobile)
    },

     getParameterByName(name, url) {
      if (!url) url = window.location.href;
      name = name.replace(/[\[\]]/g, '\\$&');
      const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
      const results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return '';
      return decodeURIComponent(results[2].replace(/\+/g, ' '));
      }


  },
  mounted() {
    //if(this.$roleUtil.checkLoginStatus(this)) {
      this.init()
    this.checkDevice()
    window.addEventListener('resize', this.checkDevice);

   // }
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.checkDevice);
  },
}
</script>

<style scoped>
.header{
  width: 100%;

}
.background{
  padding: 0;
  width: 60%;
  height: 100%;
  margin-left: 20%;
  position: relative;
}
.home {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 100vh;
  text-align: center;
  padding: 20px;
}
.mobileHeader {

  color: white;
  padding: 15px 0;
}
.content {
  flex: 1;
  padding: 20px 0;
}
.footer {
  background-color: #f1f1f1;
  padding: 10px 0;
}

@media (max-width: 600px) {
  .home {
    padding: 10px;
  }
  .header, .footer {
    padding: 10px 0;
  }
}
</style>
